import { render, staticRenderFns } from "./PopupAsView.vue?vue&type=template&id=1356d62a&"
import script from "./PopupAsView.vue?vue&type=script&lang=js&"
export * from "./PopupAsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports